<template lang="pug">
  .wrap
    VideoPlayer(:iframe="iframe")
</template>
<script>
import VideoPlayer from '@/components/VideoPlayer'
export default {
  components: {
    VideoPlayer
  },
  props: {
    iframe: String
  }
}
</script>
<style lang="scss" scoped>
  .wrap{
    padding: 2rem 0;
    max-width: 1100px;
    margin: 0 auto;
  }
</style>


